import ApiService from '../apiservice'

export default class GrupoTarefaService extends ApiService {
  constructor() {
    super('/grupoTarefa');
  }

  cadastrar(grupoTarefa) {
    return this.post('/',grupoTarefa);
  }

  listar(empresa) {
    return this.get(`/${empresa}`);
  }

  consultarGrupo(codigo) {
    return this.get(`/porCodigo/${codigo}`);
  }

  alterarGrupo(grupo) {
    return this.put('/',grupo);
  }

  excluirGrupo(codigo) {
    return this.delete(`/${codigo}`);
  }
}